
import { Vue, Component, Prop } from 'vue-property-decorator'
import CustomWrapper from '@/components/CustomWrapper.vue'

@Component({
  name: 'c-quizz-choices-item',
  components: { CustomWrapper }
})
export default class CQuizzChoiceItem extends Vue {

  @Prop({ default: 'li'}) tag!: string

}
